import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { messaging, getToken, onMessage } from '../utils/firebase-config';
import { postSendNotificationToken } from '../../assets/nodeApi/postApi/postCommonApi';

export const useFCM = () => {
  const navigate = useNavigate();
  const mutation = useMutation({
    mutationFn: postSendNotificationToken,
  });

  useEffect(() => {
    const setupFCM = async () => {
      try {
        if (!("serviceWorker" in navigator)) return;

        // Step 1: Clean up old service workers
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (const reg of registrations) {
          if (reg.scope.includes("firebase-cloud-messaging-push-scope")) {
            console.log("🧹 Unregistering duplicate FCM worker:", reg.scope);
            await reg.unregister();
          }
        }

        // Step 2: Register the correct service worker
        const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
        console.log("✅ FCM Service Worker registered:", registration.scope);

        // Step 3: Request permission
        const permission = await Notification.requestPermission();
        if (permission !== "granted") {
          console.warn("🚫 Notification permission denied");
          return;
        }

        // Step 4: Get FCM Token
        const token = await getToken(messaging, {
          vapidKey: "BFpTNkJgFTOr8C9voRA4pf-d3ijrUSakUxv21ZfZUY_kDKv8EsDofD2YJNK-0U4k_zcSp8V_BcjoPojmpLKKKKQ",
          serviceWorkerRegistration: registration,
        });

        if (token) {
          console.log("✅ FCM Token:", token);
          mutation.mutate({ organizer_id: "0", token });
        }

        // Step 5: Listen for foreground messages
        onMessage(messaging, (payload) => {
          console.log("📩 Foreground message received:", payload);
          const { title, body } = payload.notification || {};
          const data = payload.data || {};

          if (Notification.permission === "granted") {
            const notification = new Notification(title || "New Notification", {
              body,
              icon: "/favicon.png",
              data
            });

            notification.onclick = () => {
              handleNavigation(data);
            };
          }
        });

        // Listen for navigation messages from SW
        navigator.serviceWorker.addEventListener("message", (event) => {
          if (event.data?.type === "NAVIGATE") {
            console.log("🧭 Navigation message from SW:", event.data.payload);
            handleNavigation(event.data.payload);
          }
        });

      } catch (err) {
        console.error("🔥 FCM setup failed:", err);
      }
    };

    const handleNavigation = (data) => {
      if (data?.type === "hr_requested_leave_list") {
        navigate("/humanresources/leaverequestlist");
      } else if (data?.type === "trainer_requested_leave_list") {
        navigate("/trainer/leaverequest");
      } else if (data?.type === "admin_raised_ticket_test") {
        navigate("/admin/ticketlist");
      }
    };

    setupFCM();
  }, [navigate]);
};
